import React from "react";
import { Helmet } from "react-helmet";
import { clarity } from "../../utils/clarity";
const Analytics = () => {
  return (
    <div>
      <Helmet>
        <script type="text/javascript">{clarity}</script>
      </Helmet>
    </div>
  );
};

export default Analytics;
